
















import { Component } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import apiSubs, {AppExeptionsDialogsApi} from '@/components/app-exceptions-resolver/dialogs/api';
import UserApi from '@/services/rest/bemob/user';

@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons
  }
})
export default class PendingInvoiceGeneration extends Form {
  apiExeptions: AppExeptionsDialogsApi = apiSubs;
  userApi: UserApi = new UserApi();
  interval=null;
  
  close(){
    clearInterval(this.interval);
  }
  
  mounted(){
    this.interval = setInterval(async ()=>{
      const userData = await this.userApi.getUser();
      if(userData?.pendingInvoiceGeneration === false) {
        clearInterval(this.interval);
        window.location.reload()
      }
    },3000)
  }
}
